import { render, staticRenderFns } from "./dimension-field.vue?vue&type=template&id=a61f02e6&"
import script from "./dimension-field.vue?vue&type=script&lang=js&"
export * from "./dimension-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports